const CATEGORY_COLORS = {
  oficiales: {
    fill: '#0F172A',
    text: '#F8FAFC'
  },
  sponsorsAllies: {
    fill: '#FDE047',
    text: '#0F172A'
  },
  others: {
    fill: '#475569',
    text: '#F8FAFC'
  }
} as const;

export const CATEGORIES = [
  {
    name: 'Oficiales',
    color: CATEGORY_COLORS.oficiales.fill,
    textColor: CATEGORY_COLORS.oficiales.text
  },
  {
    name: 'Sponsors & Aliados',
    color: CATEGORY_COLORS.sponsorsAllies.fill,
    textColor: CATEGORY_COLORS.sponsorsAllies.text
  },
  {
    name: 'Otros',
    color: CATEGORY_COLORS.others.fill,
    textColor: CATEGORY_COLORS.others.text
  }
] as const;

export type TechCategory = typeof CATEGORIES[number]['name'];